import { render, staticRenderFns } from "./SavesInitCard.vue?vue&type=template&id=0cc7729b&scoped=true&"
import script from "./SavesInitCard.vue?vue&type=script&lang=js&"
export * from "./SavesInitCard.vue?vue&type=script&lang=js&"
import style0 from "./SavesInitCard.vue?vue&type=style&index=0&id=0cc7729b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7729b",
  null
  
)

export default component.exports